module.exports = __webpack_public_path__ + "media/images/games/k2reveal/tiger-65917c8b549703ce702b0577b441198f.png";